export default __webpack_public_path__ + "static/media/icon_linkin.a18e580d.svg";